export default __webpack_public_path__ + "static/mobile_sek2_KV03-37eb7a441d57647903b49d9f47ae6cf1.mp4";